/**
 * App mode slice — planning vs shopping.
 *
 * Ported from legacy `useStore.ts` (`mode`, `setMode`). Legacy persisted the
 * mode to `localStorage` inside the setter — that side effect is stripped
 * here (CP3). The orchestrator persists the mode via a storage adapter after
 * the reducer commits the new state.
 */

export type AppMode = 'planning' | 'shopping';

export interface AppModeState {
  mode: AppMode;
}

/**
 * Default when no persisted value exists. The orchestrator is responsible
 * for reading any persisted value at boot and seeding the state container
 * with it before the first reducer call.
 */
export const DEFAULT_APP_MODE: AppMode = 'planning';

export const initialAppModeState: AppModeState = {
  mode: DEFAULT_APP_MODE,
};

/** Narrowing helper — orchestrators use this when hydrating from storage. */
export function isAppMode(value: unknown): value is AppMode {
  return value === 'planning' || value === 'shopping';
}

// ---------------------------------------------------------------------------
// Actions
// ---------------------------------------------------------------------------

export function setMode(
  state: AppModeState,
  input: { mode: AppMode }
): AppModeState {
  return { ...state, mode: input.mode };
}
